// extracted by mini-css-extract-plugin
export default {"mbtH5":"MbtH5_mbtH5__bD9dt"};